import { render, staticRenderFns } from "./PickerOrders.vue?vue&type=template&id=3f4cca1c&"
import script from "./PickerOrders.ts?vue&type=script&lang=ts&"
export * from "./PickerOrders.ts?vue&type=script&lang=ts&"
import style0 from "./PickerOrders.vue?vue&type=style&index=0&id=3f4cca1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports